import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import loadable from '@loadable/component';
import { Controller } from 'react-hook-form';
import { FormControlLabel } from '@mui/material';
import HelperText from './HelperText';
const TelephoneInput = loadable(() => import('./TelephoneInput'));
const PhoneField = ({ control, name, label, required, }) => (_jsx(Controller, { name: name, control: control, render: ({ field: { onChange, onBlur, value,
    // name,
    // ref,
     }, fieldState: { isTouched, error, }, }) => (_jsxs(_Fragment, { children: [_jsx(FormControlLabel, { label: label, labelPlacement: "top", control: (_jsx(TelephoneInput, { fullWidth: true, name: name, value: value, onChange: onChange, onBlur: onBlur, variant: "outlined", required: required, error: isTouched && !!error, 
                    // InputLabelProps={{
                    //   style: { color: '#000000' },
                    // }}
                    InputLabelProps: {
                        sx: { color: (t) => (t.portal.global.font.color) },
                    }, InputProps: {
                        sx: {
                            '& fieldset': {
                                borderColor: (t) => (t.portal.global.font.color),
                            },
                        },
                    }, defaultCountry: "US", forceCallingCode: true, disableFormatting: true })) }), _jsx(HelperText, { name: name, error: isTouched && error?.message })] })) }));
export default PhoneField;
//# sourceMappingURL=PhoneField.js.map